import { PalettesProps, presetDarkPalettes, presetPalettes } from '@ant-design/colors';
import { alpha, createTheme } from '@mui/material/styles';
import { ThemeMode } from '~/types/config';
import { PaletteThemeProps } from '~/types/theme';

import Theme3 from './theme/theme3';

const Palette = (mode: ThemeMode) => {
  const colors: PalettesProps = mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;

  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000',
  ];
  let greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  if (mode === ThemeMode.DARK) {
    greyPrimary = [
      '#000000',
      '#141414',
      '#1e1e1e',
      '#595959',
      '#8c8c8c',
      '#bfbfbf',
      '#d9d9d9',
      '#f0f0f0',
      '#f5f5f5',
      '#fafafa',
      '#ffffff',
    ];
    greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
    greyConstant = ['#121212', '#d3d8db'];
  }
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor: PaletteThemeProps = Theme3(colors, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff',
      },
      ...paletteColor,
      text: {
        primary:
          mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.87) : paletteColor.grey[700],
        secondary:
          mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.45) : paletteColor.grey[500],
        disabled:
          mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.25) : paletteColor.grey[400],
      },
      action: {
        disabled: paletteColor.grey[300],
      },
      form: {
        input: {
          border: mode === ThemeMode.DARK ? paletteColor.grey[300] : paletteColor.grey[400],
          disabled: {
            border: mode === ThemeMode.DARK ? paletteColor.grey[200] : paletteColor.grey[300],
          },
        },
      },
      divider:
        mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.05) : paletteColor.grey['A800'],
      background: {
        paper: mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0],
        default: paletteColor.grey.A50,
        tertiary: mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0],
        cards: mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0],
        elevation1: mode === ThemeMode.DARK ? '#1B1C1E' : '#ffffff',
        elevation2: mode === ThemeMode.DARK ? '#121212' : '#fafafa',
        elevation3: mode === ThemeMode.DARK ? '#1E1E1E' : '#f5f5f5',
        elevation4: mode === ThemeMode.DARK ? '#2A292F' : '#D5D6D0',
        elevation5: mode === ThemeMode.DARK ? '#f5f5f50f' : '#fafafa',
      },
      table: {
        background: paletteColor.grey[50]!,
      },
      tooltip: {
        text: (mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0])!,
      },
    },
  });
};

export default Palette;
